var map = {
	"./blog-1.jpg": 31,
	"./blog-2.jpg": 32,
	"./blog-five1.jpg": 69,
	"./blog-five2.jpg": 70,
	"./blog-five3.jpg": 71,
	"./blog-standard-1.jpg": 25,
	"./blog-standard-2.jpg": 64,
	"./blog-standard-3.jpg": 65,
	"./call-action-widget.jpg": 204,
	"./comment-author-1.jpg": 66,
	"./comment-author-2.jpg": 67,
	"./comment-author-3.jpg": 68,
	"./footer-widget-1.jpg": 29,
	"./footer-widget-2.jpg": 30,
	"./news-1.jpg": 205,
	"./news-2.jpg": 83,
	"./news-3.jpg": 206,
	"./news-4.jpg": 207,
	"./news-5.jpg": 208,
	"./news-6.jpg": 209,
	"./news-author-1.jpg": 210,
	"./news-author-2.jpg": 84,
	"./news-author-3.jpg": 211,
	"./news-bg-two.jpg": 212,
	"./news-six1.jpg": 85,
	"./news-six2.jpg": 86,
	"./news-six3.jpg": 87,
	"./news-widget-1.jpg": 26,
	"./news-widget-2.jpg": 27,
	"./news-widget-3.jpg": 28
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15;